import { gql } from '@apollo/client';

export const REMOVE_SVA_FROM_OFFENSE = gql`
mutation removeSvaFromOffense($input: RemoveSvaFromOffenseInput!) {
  removeSvaFromOffense(input: $input) {
    __typename
    clientMutationId
    errors
    suspectVictimAffiliationUuid
  }
}
`
